module.exports = __webpack_public_path__ + "static/media/sample_return_pallets.9528019c.csv";